import * as React from "react";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { Typography, Paper, Box, Button } from "@mui/material";
import QR from "../../images/qr.png";
// import QR from "../../images/Group 1171280553.svg";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { setAuthToken } from "../../utils/setAuthToken";
import { Link, useNavigate } from "react-router-dom";

export default function QrRow() {
  const navigate = useNavigate();
  //backdrop usestates
  const [openbackdrop, setOpenbackdrop] = React.useState(false);
  const handleClose = () => {
    setOpenbackdrop(false);
  };
  const handleOpen = () => {
    setOpenbackdrop(true);
  };
  //actual use states
  const [transaction, setTransaction] = React.useState("");
  const [bal, setBal] = React.useState("");
  const getAllTransaction = (e) => {
    setAuthToken(localStorage.getItem("jwtToken"));

    axios
      .post("https://api.blockpay.co.za/blockchain/getAllTransaction", {
        limited: true,
      })
      .then((res) => {
        setTransaction(res.data.totalTransactionCount);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.message == "Unauthorized!") {
          axios
            .post("https://api.blockpay.co.za/auth/refreshToken", {
              refreshToken: localStorage.getItem("refreshToken"),
            })
            .then((res) => {
              console.log(res);
              localStorage.setItem("jwtToken", res.data.accessToken);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              localStorage.clear();
              window.location.reload();
            });
        }
      });
  };
  const getBal = (e) => {
    // e.preventDefault();
    setAuthToken(localStorage.getItem("jwtToken"));
    axios
      .get("https://api.blockpay.co.za/blockchain/allBalances", {})
      .then((res) => {
        setBal(res.data.totalBalance);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.message == "Unauthorized!") {
          axios
            .post("https://api.blockpay.co.za/auth/refreshToken", {
              refreshToken: localStorage.getItem("refreshToken"),
            })
            .then((res) => {
              console.log(res);
              localStorage.setItem("jwtToken", res.data.accessToken);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              localStorage.clear();
              window.location.reload();
            });
        }
      });
  };

  React.useEffect(() => {
    handleOpen();
    getAllTransaction();
    getBal();
    setTimeout(() => {
      handleClose();
    }, 2000);
  }, []);
  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openbackdrop}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Paper
        sx={{
          display: "flex",
          backgroundColor: "transparent",
          backgroundColor: "#111111",
          color: "#fff",
          pt: "2.313rem",
          paddingLeft: "4rem",
          "@media (max-width:900px)": {
            paddingBottom: "2rem!important",
            paddingLeft: "4rem!important",
          },
        }}
      >
        <AccountBalanceWalletOutlinedIcon
          fontSize="small"
          sx={{ marginRight: "10px" }}
        />
        <Typography sx={{}}>Wallet Overview</Typography>
      </Paper>
      <Grid
        container
        justifyContent="flex-start"
        spacing={2}
        sx={{
          backgroundColor: "#111111",
          paddingLeft: "4rem",
          pb: "31px",
          "@media (max-width:900px)": { paddingLeft: "0!important" },
        }}
      >
        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          xl={6}
          order={{ xs: 2, sm: 2, md: 1, lg: 1, xl: 1 }}
        >
          <Container sx={{ px: "0", marginLeft: "-0.875rem!important" }}>
            <Grid
              container
              spacing={2}
              direction="row"
              alignItems="center"
              sx={{ minHeight: "208px!important" }}
            >
              <Grid
                item
                xs={12}
                lg={5}
                xl={5}
                sx={{
                  padding: "0",
                  "@media (max-width:900px)": {
                    display: "flex",
                    justifyContent: "center",
                  },
                  // mr:"-4rem"
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      color: "#B4B4B4",
                      textAlign: "left",
                      width: "100%",
                    }}
                  >
                    Available balance in Rand
                  </Typography>
                  <Box
                    sx={{
                      background: "transparent",
                      display: "flex",
                      alignItems: "flex-end!important",
                      "@media (max-width:900px)": { justifyContent: "center" },
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#B4B4B4",
                        fontWeight: "500",
                        marginRight: "0.5rem",
                        fontSize: "1.2rem",
                      }}
                    >
                      R
                    </Typography>
                    <Typography
                      sx={{
                        color: "#fff",
                        fontWeight: "500",
                        pb: "0",
                        mb: "-0.2rem!important",
                        fontSize: "2rem",
                      }}
                    >
                      {bal}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                lg={5}
                xl={5}
                sx={{
                  padding: "0",
                  borderLeft: "solid 1px #fff",
                  paddingLeft: "4rem!important",
                  mb: "1rem",
                  "@media (max-width:1310px)": { borderLeft: "none!important" },
                  "@media (max-width:1200px)": {
                    paddingLeft: "16px!important",
                    display: "flex",
                  },
                  "@media (max-width:900px)": {
                    justifyContent: "center",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    mr: "2.5rem",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#B4B4B4",
                    }}
                  >
                    Transactions
                  </Typography>
                  <Typography
                    sx={{
                      color: "#fff",
                      mb: "1.2rem",
                      fontWeight: "500",
                    }}
                  >
                    {transaction}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#B4B4B4",
                    }}
                  >
                    Wallets
                  </Typography>
                  <Typography
                    sx={{
                      color: "#fff",
                      fontWeight: "500",
                    }}
                  >
                    1
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                "@media (max-width:900px)": { justifyContent: "center" },
              }}
            >
              <Button
                variant="contained"
                color="primary"
                size="large"
                type="submit"
                sx={{
                  width: "10.625rem",
                  background:
                    " linear-gradient(90deg, #05b2ff 0%, #9340e2 100%)",
                  borderRadius: "5px",
                  mb: "1rem",
                  // marginRight: "1.275rem",
                }}
                component={Link}
                to="/withdraw"
              >
                <span>Withdraw</span>
              </Button>
              {/* <Button
                variant="contained"
                size="large"
                type="submit"
                sx={{
                  width: "10.625rem",
                  background: "#171717",
                  borderRadius: "10px",
                  border: "0.25px solid ",
                }}
              >
                <span className="buttonSignText">Receive</span>
              </Button> */}
            </Grid>
          </Container>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          xl={6}
          order={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}
          sx={{
            "@media (max-width:900px)": {
              padding: "0px 28px 0px 24px!important",
            },
          }}
        >
          <Box
            component="img"
            sx={{
              height: "18rem",
              "@media (max-width:435px)": { width: "230px", height: "auto" },
            }}
            src={QR}
          />
        </Grid>
      </Grid>
    </>
  );
}
